import React from "react";
import { CircularProgress } from "@mui/material";
import { StyledBookingFlowButton } from "../../BookingScheduleContainer/BookingScheduleContainer.style";
import { paletteColors } from "../../../../styles/muiTheme";
import { billCycle } from "../types";
import { BUTTON_TEXT } from "../constants";

interface IPurchaseButtonProps {
  billingCycle: billCycle;
  isLoading: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

export const PurchaseButton = ({
  billingCycle,
  isLoading,
  isDisabled,
  onClick,
}: IPurchaseButtonProps) => {
  const getButtonText = () => {
    if (isLoading) return null;
    return billingCycle === "perMonth" ?
      BUTTON_TEXT.CONTINUE_SCRATCHPAY :
      BUTTON_TEXT.CONFIRM_PURCHASE;
  };

  return (
    <StyledBookingFlowButton
      fullWidth
      color="primary"
      size="small"
      className="!my-4 !rounded-full"
      disabled={isDisabled}
      onClick={onClick}
      sx={{
        "fontFamily": "geograph-medium, sans-serif",
        "fontSize": "14px",
        "lineHeight": "14px",
        "fontWeight": 500,
        "height": "40px",
        "borderRadius": "100px",
        "&:hover": {
          background: isLoading ? paletteColors.primary.main : undefined,
        },
      }}
    >
      {isLoading ? (
        <CircularProgress size={20} sx={{ color: paletteColors.black.main }} />
      ) : (
        getButtonText()
      )}
    </StyledBookingFlowButton>
  );
};
